import { hexToRgb, srgbToLinear } from 'helpers/colorTools.helper';

/**
 * Given a linear color, returns a boolean indicating whether or not the color
 * should receive the saloon style treatment: Cigar, Tumbleweed, Mushroom
 *
 * @param {Array<number>} linearColor - linear color as an array of 3 numbers
 *    in the range [0, 1]
 * @return {boolean} whether or not the given color should receive the saloon
 *    style treatment
 */
const isSaloonStyle = (linearColor) => {
  const applyToSaloon = [
    '#39261D', // Cigar
    '#855839', // Tumbleweed
    '#858166' // Mushroom
  ].map(s => srgbToLinear(hexToRgb(s)));
  // is linearColor included in applyToSaloon
  return applyToSaloon.filter(c => c[0] === linearColor[0] && c[1] === linearColor[1] && c[2] === linearColor[2]).length > 0
}

const leathersGrouped = {
  CineSuede: {
    price: 0,
    tooltip:
        'An extremely soft, high quality suede-textured fabric that provides a warm and cozy, true-to-theater cinematic experience.',
    sampleImage: require('../img/cinesuede.png'),
    overwriteChannels: (channels, linearColor, replaceTexture = true) => {
      const normalTexture = (window.api.textures.filter((t) => t.name === 'cinesuede_normal.jpg') || [])[0]
      // const bumpTexture = (window.api.textures.filter((t) => t.name === 'leather_diff_levels.jpg') || [])[0]
      const metalnessTexture = (window.api.textures.filter((t) => t.name === 'leather_diff_levels.jpg') || [])[0]

      if (replaceTexture) {
        if (normalTexture) {
          channels.NormalMap.texture = { ...(channels.NormalMap.texture || {}), uid: normalTexture.uid }
        }
      }
      // if (bumpTexture) {
      //   channels.BumpMap.texture = { ...(channels.BumpMap.texture || {}), uid: bumpTexture.uid }
      // }
      if (metalnessTexture) {
        channels.MetalnessPBR.texture = { ...(channels.MetalnessPBR.texture || {}), uid: metalnessTexture.uid }
      }
      channels.SpecularF0.factor = 0.6
      channels.RoughnessPBR.factor = 0.95
      // channels.BumpMap.enable = true
      channels.CavityPBR.enable = false
      channels.NormalMap.enable = true
      channels.MetalnessPBR.enable = true
      channels.MetalnessPBR.factor = 0.38

      channels.AlbedoPBR.color = linearColor
      channels.DiffusePBR.color = linearColor
      channels.DiffuseColor.color = linearColor

      if(channels.NormalMap.UVTransforms !== undefined) {
        channels.NormalMap.UVTransforms.scale= [0.5, 0.5]
      }
      if(channels.Sheen !== undefined && channels.Sheen.UVTransforms !== undefined){
        channels.Sheen.UVTransforms.scale= [0.2, 0.2]
      }
      if(channels.SheenRoughness.UVTransforms !== undefined){
        channels.SheenRoughness.UVTransforms.scale= [0.01, 0.01]
      }
      return channels
    },
    // Theater Red 
    // Bordeaux 
    // Royal Blue 
    // Navy 
    // Jet Black 
    // Charcoal : Franklin  
    // Mink : Franklin  
    // Dark Chocolate 
    // Camel 
    // Fawn : Franklin  
    // Steel : Franklin  
    // Metal : Franklin  
    // Platinum 
    // Taupe 
    // Oyster 
    // Ivory : Urban  
    // Cinder : Franklin  
    // Mocha : Urban  
    "colors": {
      "Jet Black": "#0e0e0e",
      "Royal Blue": "#060d4c",
      "Charcoal": "#1f1f1f",
      "Dark Chocolate": "#21120d",
      "Navy": "#242c2f",
      "Mink": "#322525",
      "Bordeaux": "#330f0f",
      "Metal": "#48514D",
      "Mocha": "#505150",
      "Camel": "#543c18",
      "Steel": "#636660",
      "Theater Red": "#7B0016",
      "Taupe": "#867058",
      "Fawn": "#87795A",
      "Cinder": "#A59F92",
      "Platinum": "#ACA497",
      "Ivory": "#C3BEAB",
      "Oyster": "#C3BEAB"
    }
  },



  // Peppercorn 
  // Caramel 
  // Carbon 
  // Russet 
  // Khaki 
  // Biscotti 
  // Afterdusk 
  // Burlap 
  // Smoke 
  // Baltic Blue 
  // Cherrywood 
  // Shark Skin 
  // Sea Salt 
  // Barley 
  // Black 
  // Cigar 
  // Mushroom 
  // Tumbleweed 
  'Valentino Leather': {
    price: 400,
    tooltip:
      'Our standard, natural, top grain leather is sourced from Italy, and is of the highest quality our customers expect.',
    sampleImage: require('../img/valentino.png'),
    overwriteChannels: (channels, linearColor, replaceTexture = true) => {
      // valentino_saloon_nrm.jpg
      const normalTexture = (window.api.textures.filter((t) => t.name === 'valentino_leather_normal.jpg') || [])[0]
      const cavityTexture = (window.api.textures.filter((t) => t.name === 'valentino_leather_cavity.jpg') || [])[0]
      const valentinoSaloonTexture = (window.api.textures.filter((t) => t.name === 'valentino_saloon_nrm.jpg') || [])[0]
      console.log('this', this);
      if (replaceTexture) {
        // const applyToSaloon = isSaloonStyle(linearColor);
        const applyToSaloon = true;
        console.log('applyToSaloon', {applyToSaloon, linearColor});
        if(valentinoSaloonTexture && applyToSaloon) {
          channels.NormalMap.texture = { ...(channels.NormalMap.texture || {}), uid: valentinoSaloonTexture.uid }
        }else if (normalTexture) {
          channels.NormalMap.texture = { ...(channels.NormalMap.texture || {}), uid: normalTexture.uid }
        }
      }
      if (cavityTexture) {
        channels.CavityPBR.texture = { ...(channels.CavityPBR.texture || {}), uid: cavityTexture.uid }
      }

      channels.SpecularF0.factor = 0.2
      channels.RoughnessPBR.factor = 0.62
      channels.BumpMap.enable = false
      channels.NormalMap.enable = true
      channels.CavityPBR.enable = true
      channels.MetalnessPBR.enable = false

      channels.AlbedoPBR.color = linearColor
      channels.DiffusePBR.color = linearColor
      channels.DiffuseColor.color = linearColor
      if(channels.NormalMap.UVTransforms !== undefined) {
        channels.NormalMap.UVTransforms.scale= [1, 1]

      }

      return channels
    },
    // Black, 
    // Charcoal, 
    // Bayou, -
    // Chocolate, -
    // Coal -, 
    // Cream - , 
    // Fire Engine Red, 
    // Wine - , 
    // Grey - , 
    // Harness Brown - , 
    // Hazelnut, 
    // Mocha, 
    // Ivory - , 
    // Mist Blue, 
    // Navy, 
    // Dark Cherry, 
    // Smoke Grey, 
    // Taupe -



    "colors": {

      "Black": "#0F0F0F",
      Charcoal: '#232323',
      Bayou: '#112936',
      Chocolate: '#331E15',
      Coal: '#47433e',
      Cream: '#978264',
      'Fire Engine Red': '#6d0907',
      Wine: '#3C1B1D',
      Grey: '#616661',
      'Harness Brown': '#612D02',
      Hazelnut: '#463528',
      Mocha: '#84654f',
      Ivory: '#9B917B',
      'Mist Blue': '#384447',
      Navy: '#2C353D',
      'Dark Cherry': '#431e1f',
      'Smoke Grey': '#47433e',
      'Taupe': '#695443',

    }
  },
  'Silk Leather': {
    price: 600,
    tooltip:
        'Our most popular option – an extremely buttery soft, comfortable, and flexible performance material that has the visual and spill resistant qualities of leather. ',
    sampleImage: require('../img/silk.png'),
    overwriteChannels: (channels, linearColor, replaceTexture = true) => {
      const normalTexture = (window.api.textures.filter((t) => t.name === 'silk_leather_normal.jpg') || [])[0]
      const cavityTexture = (window.api.textures.filter((t) => t.name === 'silk_leather_cavity.jpg') || [])[0]

      if (replaceTexture) {
        if (normalTexture) {
          channels.NormalMap.texture = { ...(channels.NormalMap.texture || {}), uid: normalTexture.uid }
        }
      }
      if (cavityTexture) {
        channels.CavityPBR.texture = { ...(channels.CavityPBR.texture || {}), uid: cavityTexture.uid }
      }
      channels.SpecularF0.factor = 0.2
      channels.RoughnessPBR.factor = 0.6
      channels.BumpMap.enable = false
      channels.NormalMap.enable = true
      channels.CavityPBR.enable = true
      channels.MetalnessPBR.enable = false

      channels.AlbedoPBR.color = linearColor
      channels.DiffusePBR.color = linearColor
      channels.DiffuseColor.color = linearColor
      if(channels.NormalMap.UVTransforms !== undefined) {
        channels.NormalMap.UVTransforms.scale= [1, 1]

      }
      return channels
    },




    // Black Onyx 
    // Indigo 
    // Cambridge Blue 
    // Caramel 
    // Hazey 
    // Ash 
    // Olive 
    // Shiitake 
    // Coffee Bean 
    // Truffle 
    // Desert Clay 
    // Salsa 
    // Pompeiian Red 
    // Cabernet 
    // Cream 
    // Bone 
    // Desert Clay 
    // Evening Blue 
    // Seaweed 
    "colors": {
      "Evening Blue": "#080e20",
      "Black Onyx": "#090909",
      "Seaweed": "#1B463D",
      "Indigo": "#1a1b2d",
      "Cabernet": "#341F27",
      "Coffee Bean": "#2A140E",
      "Shiitake": "#413735",
      "Truffle": "#453329",
      "Ash": "#47433e",
      "Cambridge Blue": "#4A5861",
      "Olive": "#4D4D41",
      "Caramel": "#57301d",
      "Hazey": "#3A3B3D",
      "Pompeiian Red": "#5b0401",
      "Salsa": "#79423D",
      "Desert Clay": "#84654f",
      "Bone": "#C2BBA9",
      "Cream": "#DFD7C0"
    }
  },

}

const leathers = Object.keys(leathersGrouped).map((leatherName) =>
  Object.keys(leathersGrouped[leatherName].colors).map((colorName) => ({
    leatherName,
    colorName,
    leatherPrice: leathersGrouped[leatherName].price,
    hex: leathersGrouped[leatherName].colors[colorName],
    overwriteChannels: leathersGrouped[leatherName].overwriteChannels.bind(leathersGrouped[leatherName]),
    sampleImageUrl: leathersGrouped[leatherName].sampleImage,
    tooltip: leathersGrouped[leatherName].tooltip,
  }))
)

// console.log(leathers)

export default leathers
